export const SAMPLE_GENERIC_JOB_TITLES = [
    'Account Manager',
    'Financial Controller',
    'Full-stack Developer'
];
